import { FILE_INDEX_INSERT_BUFFER, FILE_INDEX_INTERRUPT_CHECK_EVERY } from './file-index-persist-constants.js';
import { assertFileIndexPersistNotShutdown } from './file-index-persist-shutdown.js';
import { persistFileIndexPaths } from './persist-file-index-paths.js';
import { walkWorkspaceTreeSync } from './walk-workspace-tree.js';

/**
 * Walk the workspace and replace `file_index_child_path` rows in one transaction.
 * Uses a small insert buffer so we never hold the full file list in memory.
 */
export function persistFileIndexForResolvedCwd(resolved: string): number {
  const paths: string[] = [];
  let entriesSinceInterruptCheck = 0;
  walkWorkspaceTreeSync(resolved, resolved, (rel) => {
    if (++entriesSinceInterruptCheck >= FILE_INDEX_INTERRUPT_CHECK_EVERY) {
      entriesSinceInterruptCheck = 0;
      assertFileIndexPersistNotShutdown();
    }
    paths.push(rel);
    if (paths.length % FILE_INDEX_INSERT_BUFFER === 0) assertFileIndexPersistNotShutdown();
  });
  return persistFileIndexPaths(resolved, paths);
}
